const KCommonEInvoiceFilters = [
  // {
  //   filterKey: "CLASS_NAME",
  //   filterValueType: "STRING",
  //   filterValue: {
  //   value1: ""
  // },
  //   operator: "E",
  // },
  {
    filterKey: "ET_DOC_ID",
    filterValueType: "STRING",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
  {
    filterKey: "PROGRESSIVE",
    filterValueType: "NUMBER_LONG",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
  {
    filterKey: "FISCAL_YEAR",
    filterValueType: "NUMBER_INTEGER",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
  {
    filterKey: "INVOICE_NUMBER",
    filterValueType: "STRING",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
  {
    filterKey: "INVOICE_DATE",
    filterValueType: "DATE_LEGACY",
    filterValue: {
      value1: null,
    },
    operator: "E",
  },
  {
    filterKey: "NET_AMOUNT",
    filterValueType: "NUMBER_BIG_DECIMAL",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
  {
    filterKey: "VAT_AMOUNT",
    filterValueType: "NUMBER_BIG_DECIMAL",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
  {
    filterKey: "TOTAL_AMOUNT",
    filterValueType: "NUMBER_BIG_DECIMAL",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
  {
    filterKey: "DOC_TYPE",
    filterValueType: "STRING",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
  {
    filterKey: "RELATED_INVOICES_NUMBERS",
    filterValueType: "STRING",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
  {
    filterKey: "FILE_NAME",
    filterValueType: "STRING",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
  {
    filterKey: "SDI_ID",
    filterValueType: "NUMBER_LONG",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
  // {
  //   filterKey: "TXRX_DENOMINAZIONE",
  //   filterValueType: "STRING",
  //   filterValue: {
  //     value1: "",
  //   },
  //   operator: "E",
  // },
  // {
  //   filterKey: "TXRX_PARTITA_IVA",
  //   filterValueType: "STRING",
  //   filterValue: {
  //     value1: "",
  //   },
  //   operator: "E",
  // },
  {
    filterKey: "TIMING",
    filterValueType: "DATE_LEGACY",
    filterValue: {
      value1: null,
    },
    operator: "E",
  },
  {
    filterKey: "MSG_TYPE",
    filterValueType: "STRING",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
];

const KActiveEInvoiceFilters = [
  {
    filterKey: "RX_DENOMINAZIONE",
    filterValueType: "STRING",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
  {
    filterKey: "RX_PARTITA_IVA",
    filterValueType: "STRING",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
];

const KPassiveEInvoiceFilters = [
  {
    filterKey: "TX_DENOMINAZIONE",
    filterValueType: "STRING",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
  {
    filterKey: "TX_PARTITA_IVA",
    filterValueType: "STRING",
    filterValue: {
      value1: "",
    },
    operator: "E",
  },
];

function getActiveEInvoiceFilters() {
  const commonFilters = JSON.parse(JSON.stringify(KCommonEInvoiceFilters));
  const activeFilters = JSON.parse(JSON.stringify(KActiveEInvoiceFilters));
  return commonFilters.concat(activeFilters);
}

function getPassiveEInvoiceFilters() {
  const commonFilters = JSON.parse(JSON.stringify(KCommonEInvoiceFilters));
  const passiveFilters = JSON.parse(JSON.stringify(KPassiveEInvoiceFilters));
  return commonFilters.concat(passiveFilters);
}

function getAllEInvoiceFilters() {
  const commonFilters = JSON.parse(JSON.stringify(KCommonEInvoiceFilters));
  const activeFilters = JSON.parse(JSON.stringify(KActiveEInvoiceFilters));
  const passiveFilters = JSON.parse(JSON.stringify(KPassiveEInvoiceFilters));
  return commonFilters.concat(activeFilters).concat(passiveFilters);
}

export const KEInvoiceFilters = {
  getAllEInvoiceFilters,
  getActiveEInvoiceFilters,
  getPassiveEInvoiceFilters,
};
